import styled from 'styled-components';
import { Td } from '../../../../components/styles/table-style';

interface ThProps {
  $sortable?: boolean;
}

export const Th = styled.th<ThProps>`
  color: #696969;
  background-color: #f5f5f5;
  text-align: start;
  border: 0;
  font-size: .85rem;
  font-weight: 400;
  padding-left: 1.2rem;
  cursor: ${({ $sortable }) => ($sortable ? 'pointer' : 'default')};
  transition: background 0.2s;
  &:hover {
    background: ${({ $sortable }) => ($sortable ? '#f1f3f5' : '#f5f5f5')};
  }
`;

export const ConfigMenuWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  z-index: 10;
`;

export const ConfigMenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bdbdbd;
  transition: color 0.2s, background 0.2s;
  &:hover {
    color: #495057;
    background: rgba(0, 0, 0, 0.05);
  }
`;

export const ColumnMenu = styled.div`
  background: white;
  padding: .5rem;
  border-radius: 16px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  width: 250px;
  max-height: 40vh;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 20;
`;

export const ColumnMenuTitle = styled.strong`
  font-size: 14px;
`;

export const ColumnMenuList = styled.div`
  overflow-y: auto;
  padding-right: 0.5rem;
  margin-right: -0.5rem;
  margin-top: 0;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
    
    &:hover {
      background: #a0aec0;
    }
  }

  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 #f1f1f1;
`;

export const ColumnMenuItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: .1rem;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f7fafc;
  }

  label {
    margin-left: 1rem;
    color: #4a5568;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
  }
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const StyledCheckbox = styled.div<{ checked: boolean }>`
  display: inline-block;
  width: 18px;
  height: 18px;
  background: ${props => props.checked ? '#0090D3' : '#fff'};
  border: 2px solid ${props => props.checked ? '#0090D3' : '#cbd5e0'};
  border-radius: 6px;
  transition: all 0.2s ease;
  position: relative;
  cursor: pointer;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  &:after {
    content: '';
    position: absolute;
    display: ${props => props.checked ? 'block' : 'none'};
    left: 4px;
    width: 4px;
    top: 1px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

export const ThContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TableContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CenteredCell = styled(Td)`
  text-align: center;
`;

const CenteredContainer = styled.div`
  padding-top: 20px;
  text-align: center;
`;

export const MessageContainer = styled(CenteredContainer)`
  font-weight: 500;
  color: #6c757d;
`;

export const ErrorMessage = styled(MessageContainer)`
  color: var(--danger-color, #dc3545);
`;

export const StatusBadge = styled.span<{ status: boolean | null | undefined }>`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;

  ${props => {
    if (props.status === true) {
      return `
        background-color: #10B981;
        color: white;
        border: 1px solid #10B981;
      `;
    }
    if (props.status === false) {
      return `
        background-color: #EF4444;
        color: white;
        border: 1px solid #EF4444;
      `;
    }
    return `
      background-color: white;
      color: black;
      border: 1px solid black;
    `;
  }}
`;